/** V2 `Diamond` (kit.jsx:34-36) over the hub canonical `Diamond`: solid is fill-only, `dashed` a 1.5px dashed frame. */
import React from 'react';
import { Diamond as HubDiamond } from '../clients/hub/designSystem';

export interface DiamondProps {
  size?: number;
  color?: string;
  dashed?: boolean;
  style?: React.CSSProperties;
}

export function Diamond({ size = 6, color = 'var(--indigo)', dashed, style }: DiamondProps): React.ReactElement {
  return dashed
    ? <HubDiamond size={size} color={color} outline="dashed" outlineWidth={1.5} style={style} />
    : <HubDiamond size={size} color={color} filled outline="none" style={style} />;
}

export default Diamond;
